import './Aboutme.css';

const Aboutme=()=>{
document.title="Noel Saj|About me";
return(
    <div>
    I am a Final year student pursuing B-Tech in Information Technology from NIT Srinagar.A passionate Developer and technology enthusiast.College life has made me fast and adaptive for learning new technologies.I have developed several front ends and few backends of several projects.
    My tech stack is MERN.I am also passionate about DSA and has solved 400+ Questions in various coding platforms.  
    </div>
);
}

export default Aboutme;